import "./Contact.css";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock
} from "react-icons/fa";

function Contact() {
  return (
    <>

      {/* =========================
            HERO
      ========================= */}

      <section
        className="cc-contact-hero"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1920&q=80')"
        }}
      >

        <div className="cc-contact-overlay">

          <h1>Contact Us</h1>

          <p>
            We'd love to hear from you. Contact our expert team
            for buying, selling or renting your dream property.
          </p>

        </div>

      </section>



      {/* =========================
          CONTACT INFO
      ========================= */}

      <section className="cc-contact-info">

        <div className="cc-contact-card">

          <div className="cc-contact-icon">
            <FaPhoneAlt />
          </div>

          <h3>Call Us</h3>

          <p>+91 98765 43210</p>

          <p>+91 99887 66554</p>

        </div>

        <div className="cc-contact-card">

          <div className="cc-contact-icon">
            <FaEnvelope />
          </div>

          <h3>Email</h3>

          <p>info@InteriorMart.com</p>

          <p>support@InteriorMart.com</p>

        </div>

        <div className="cc-contact-card">

          <div className="cc-contact-icon">
            <FaMapMarkerAlt />
          </div>

          <h3>Office Address</h3>

          <p>
            Zirakpur, SAS Nagar,
            Punjab, India
          </p>

        </div>

        <div className="cc-contact-card">

          <div className="cc-contact-icon">
            <FaClock />
          </div>

          <h3>Working Hours</h3>

          <p>Mon - Sat : 9 AM - 7 PM</p>

          <p>Sunday : Closed</p>

        </div>

      </section>

      {/* ==========================================
                FAQ SECTION
========================================== */}

<section className="cc-contact-faq">

    <div className="cc-contact-faq-left">

        <span>FAQ</span>

        <h2>
            Frequently Asked Questions
        </h2>

        <p>
            Find answers to the most common questions regarding
            buying, selling, renting and property consultation.
        </p>

    </div>

    <div className="cc-contact-faq-right">

        <div className="cc-contact-faq-item">

            <h3>
                How can I schedule a property visit?
            </h3>

            <p>
                Simply contact our team using the enquiry form or
                call us directly. Our executive will arrange your
                property visit at your preferred time.
            </p>

        </div>

        <div className="cc-contact-faq-item">

            <h3>
                Do you charge any consultation fee?
            </h3>

            <p>
                Initial consultation is completely free. We guide
                you through the buying or selling process before
                discussing any service charges.
            </p>

        </div>

        <div className="cc-contact-faq-item">

            <h3>
                Can you help with home loans?
            </h3>

            <p>
                Yes. We work with trusted banking partners to help
                you find the best home loan options with competitive
                interest rates.
            </p>

        </div>

        <div className="cc-contact-faq-item">

            <h3>
                Which areas do you serve?
            </h3>

            <p>
                We primarily serve Zirakpur, Chandigarh, Mohali,
                Panchkula and nearby locations with premium real
                estate services.
            </p>

        </div>

    </div>

</section>



{/* ==========================================
                CTA SECTION
========================================== */}

<section
className="cc-contact-cta"
style={{
backgroundImage:
"url('https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=1920&q=80')"
}}
>

<div className="cc-contact-cta-overlay">

<span>LET'S CONNECT</span>

<h2>
Looking For Your Dream Property?
</h2>

<p>

Whether you are buying, selling or investing,
our experienced team is here to help you make
the right decision.

</p>

<div className="cc-contact-cta-buttons">

<button className="cc-contact-btn-one">
Call Now
</button>

<button className="cc-contact-btn-two">
Get Free Consultation
</button>

</div>

</div>

</section>

    </>
  );
}

export default Contact;